import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticateGuard } from '../guards/authenticate.guard';
import { TabsPage } from './tabs.page';

const routes: Routes = [
  {
    path: '',
    component: TabsPage,
    children: [
      {
        path: 'home',
        loadChildren: () => import('../pages/start/start.module').then(m => m.StartPageModule)
      },
      {
        path: 'guides',
        loadChildren: () => import('../pages/homeguide/homeguide.module').then(m => m.HomeguidePageModule)
      },
      {
        path: 'create',
        loadChildren: () => import('../pages/create-travel-guide/create-travel-guide.module').then(m => m.CreateTravelGuidePageModule)
      },
      {
        path: 'activity',
        loadChildren: () => import('../pages/home/home.module').then(m => m.HomePageModule)
      },
      {
        path: 'favorites',
        loadChildren: () => import('../pages/favorite-travel-guides/favorite-travel-guides.module').then(m => m.FavoriteTravelGuidesPageModule)
      },
      // {
      //   path: 'explora',
      //   loadChildren: () => import('../pages/explorar/explorar.module').then( m => m.ExplorarPageModule)
      // },
/*       
      {
        path: 'home',
        loadChildren: () => import('../pages/home/home.module').then(m => m.HomePageModule)
      },

      {
        path: 'events',
        loadChildren: () => import('../pages/events/events.module').then( m => m.EventsPageModule)
      },
      {
        path: 'reserves',
        loadChildren: () => import('../pages/reserves/reserves.module').then(m => m.ReservesPageModule)
      },
      {
        path: 'map',
        loadChildren: () => import('../pages/map/map.module').then(m => m.MapPageModule)
      },
      {
        path: 'explore',
        loadChildren: () => import('../pages/explore/explore.module').then( m => m.ExplorePageModule)
      },
      {
        path: 'experiences',
        loadChildren: () => import('../pages/experience/experience.module').then( m => m.ExperiencePageModule)
      },
      {
        path: 'albums',
        loadChildren: () => import('../pages/albums/albums.module').then( m => m.AlbumsPageModule)
      },   */  
      {
        path: '**',
        redirectTo: '/app/home',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class TabsPageRoutingModule {}
